import React, { Fragment } from 'react';
import PageTitle from '../../components/pagetitle/PageTitle';
import Header from '../../components/header/Header';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import RetailBusiness from '../../components/WorkWithTCUK/RetailBusiness';
import RetailAgent from '../../components/WorkWithTCUK/RetailAgent';

function WorkWithTCUKPage(props) {
  return (
    <Fragment>
      <div className='index_ico page_wrapper'>
        <Header />
        <main className="page_content">
          <PageTitle pageTitle={'Work With TCUK'} pagesub={'Home'} />
          <RetailBusiness />
          <hr style={{padding:0,margin:0,height:"1px", backgroundColor:"gray"}}/>
          <RetailAgent />
        </main>
        <Footer />
        <Scrollbar />
      </div>
    </Fragment>
  );
}

export default WorkWithTCUKPage;
